import React from 'react'
import { render } from 'react-dom'
import { UALProvider, withUAL } from '@eoscostarica/ual-reactjs-renderer'
import { ApolloProvider } from '@apollo/client'

import App from './App'
import { client } from './graphql'
import * as serviceWorker from './serviceWorker'
import { SharedStateProvider } from 'context/state.context'
import { walletConfig } from 'config'

const SharedStateProviderWithUAL = withUAL(SharedStateProvider)

render(
  <UALProvider
    chains={[walletConfig.network]}
    authenticators={walletConfig.authenticators}
    appName={walletConfig.appName}
  >
    <SharedStateProviderWithUAL>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </SharedStateProviderWithUAL>
  </UALProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register()
